
import { chunkArray } from "~/common/helpers";
import IconCategory from "../v2/icons/IconCategory.vue";

export default {
  components: {
    IconCategory,
  },

  props: {
    title: {
      type: String,
    },
    list: {
      type: [Object, Array],
    },
    districtUrl: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      colCount: 3,
    };
  },

  computed: {
    categoryCols() {
      return chunkArray(this.list, this.colCount);
    },
  },
};
